import React from "react";
import "../styles/Client.css";

import Client1 from "../assets/clients/DigiGrow1.webp";
import Client2 from "../assets/clients/eduitalent.webp";
import Client3 from "../assets/clients/sankalp.webp";
import Client4 from "../assets/clients/speedroutes.webp";
import Client5 from "../assets/clients/devrishi.webp";
import Client6 from "../assets/images/vmdata.webp";

const Client = () => {
  const logos = [Client1, Client2, Client3, Client4, Client5, Client6];

  return (
    <div className="client-section">
         <p className="client-description">
        Our Clients
      </p>
      <h2 className="client-heading">
        Trusted by leading Clients worldwide
      </h2>
      {/* Slider */}
      <div className="slider">
        <div className="slide-track">
          {logos.concat(logos).map((logo, index) => (
            <div className="slide" key={index}>
              <img src={logo} alt="client" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Client;
// import React from "react";
// import "../styles/Client.css";

// import Client1 from "../assets/clients/src/assets/clients/DigiGrow1.webp";
// import Client2 from "../assets/clients/eduitalent.webp";
// import Client3 from "../assets/clients/sankalp.webp";
// import Client4 from "../assets/clients/speedroutes.webp";
// import Client5 from "../assets/clients/devrishi.webp";
// import Client6 from "../assets/images/vmdata.webp";

// const ClientSection = () => {
//   const clients = [
//    Client1,
//    Client2,
//    Client3,
//    Client4,
//    Client5,
//    Client6,
//   ];

//   return (
//     <section className="client-section">
//       <div className="client-container">
        
//         {/* LEFT CONTENT */}
//         <div className="client-left">
//           <span className="client-subtitle">Clientele List</span>

//           <h2>
//             Not just clients, they <br />
//             are more like partners
//           </h2>

//           <button className="client-btn">
//             <span>→</span> News & Awards
//           </button>
//         </div>

//         {/* RIGHT GRID */}
//         <div className="client-grid">
//           {clients.map((logo, index) => (
//             <div className="client-box" key={index}>
//               <img src={logo} alt="client-logo" />
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ClientSection;